import React from "react";
import PropTypes from "prop-types";

import { gatherClasses } from "../../lib/utils";
import { OrionContext } from "../orionContext/orionContext";
import "./floater.scss";
import "./msp-provider.scss";

class Floater extends React.Component {
  componentDidUpdate(prevProps) {
    const { show, onShow, onHide } = this.props;
    // Below condition is making sure that the event gets fired on prop change only
    if (prevProps.show === show) {
      return;
    }

    setTimeout(() => {
      if (show) {
        onShow();
      } else {
        onHide();
      }
    }, 300);
  }

  render() {
    const { dataTestId, position, show, children, overlay, onOverlayClick } =
      this.props;
    const { dellDoubleHeader } = this.context || {};

    return (
      // eslint-disable-next-line react/jsx-fragments
      <React.Fragment>
        <div
          data-testid={dataTestId}
          className={gatherClasses(
            this.props,
            "oui-floater",
            dellDoubleHeader && "oui-double-header-support",
            `oui-float-${position}`,
            show ? "oui-show" : null
          )}
        >
          {children}
        </div>
        {overlay && show ? (
          <div
            className="oui-overlay"
            onClick={onOverlayClick}
            aria-hidden="true"
          />
        ) : null}
      </React.Fragment>
    );
  }
}

Floater.contextType = OrionContext;

Floater.propTypes = {
  position: PropTypes.oneOf(["left", "right"]),
  show: PropTypes.bool,
  overlay: PropTypes.bool,
  onOverlayClick: PropTypes.func,
  onShow: PropTypes.func,
  onHide: PropTypes.func,
  dataTestId: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

Floater.defaultProps = {
  position: "left",
  show: false,
  overlay: false,
  onShow: () => {},
  onHide: () => {},
  dataTestId: "orion-floater"
};

Floater.displayName = "OrionFloater";

export default Floater;
